import { useQueryList } from '@percent/partner-dashboard/common/hooks'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'

export const useCampaignsTable = () => {
  const { workplaceGivingService } = useServices()

  return useQueryList(workplaceGivingService.getGivingCampaignsList, {
    pageSize: 10
  })
}
